<template>
  <div class="bg-container">
    <v-container fluid fill-height :style="{ maxWidth: '1200px', paddingLeft: '0px', paddingRight: '0px'}">
      <v-layout flex align-center :class="windowWidth < 375 ? 'pt-110' : ''">
        <v-flex xs12 sm8 md6 offset-sm3 offset-md3>
          <v-card class="no-shadow no-background">
            <v-card-title primary-title>
              <h1 class="headline">Log in to GSMG</h1>
            </v-card-title>
            <v-card-text v-if="step == 1">
              <p v-if="reset_success" class="status-success">
                Your password has been reset successfully!
              </p>
              <p v-else class="head-description">
                New customer?
                <router-link to="/register">Register here</router-link>
              </p>
            </v-card-text>
            <v-card-text v-if="step == 2">
              <p class="head-description">
                Please enter the 2FA code from your Google Authenticator app
              </p>
            </v-card-text>
            <v-card-text v-if="step == 1">
              <v-form
                  @submit.prevent="check2fa"
                  @keydown="form.onKeydown($event)"
              >
                <!-- Email -->
                <v-text-field
                    v-model="form.email"
                    label="E-Mail"
                    name="email"
                    placeholder="E-Mail"
                    single-line
                    required
                    autofocus
                    :error="form.errors.has('email')"
                ></v-text-field>
                <HasError :form="form" field="email"></HasError>
                <!-- Password -->
                <v-text-field
                    v-model="form.password"
                    label="Password"
                    name="password"
                    :type="type"
                    placeholder="Password"
                    single-line
                    required
                    :error="form.errors.has('password')"
                >
                  <template v-slot:append>
                    <img
                        width="24"
                        height="24"
                        :src="password_icon"
                        @click="togglePassword"
                    />
                  </template>
                </v-text-field>
                <HasError :form="form" field="password"></HasError>
                <!-- Remember Me -->
                <v-layout class="row wrap">
                  <v-flex md6 sm6 xs6>
                    <v-btn type="submit" :loading="form.busy" color="primary"
                    >Confirm</v-btn
                    >
                  </v-flex>
                  <v-layout xs6 md6 sm6 class="justify-end mt-3">
                    <router-link to="/password/reset" class="forgot-password">
                      Forgot password?
                    </router-link>
                  </v-layout>
                </v-layout>

                <v-layout>
                  <v-flex> </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <v-card-text v-if="step == 2">
              <v-form
                  @submit.prevent="login2fa"
                  @keydown="form.onKeydown($event)"
              >
                <v-card-text primary-title class="description-2fa">
                  <p>2FA code</p>
                </v-card-text>

                <!-- two factor -->
                <v-flex row>
                  <input
                      ref="c1"
                      v-model="c1"
                      name="c1"
                      required
                      autocomplete="off"
                      class="input2fa"
                      maxlength="1"
                      size="1"
                      autofocus
                      @paste="onPaste"
                      @keydown="onKeydown($event, 'c1')"
                  />
                  <input
                      v-model="c2"
                      name="c2"
                      required
                      autocomplete="off"
                      class="input2fa"
                      maxlength="1"
                      size="1"
                      @paste="onPaste"
                      @keydown="onKeydown($event, 'c2')"
                  />
                  <input
                      v-model="c3"
                      name="c3"
                      required
                      autocomplete="off"
                      class="input2fa"
                      maxlength="1"
                      size="1"
                      @paste="onPaste"
                      @keydown="onKeydown($event, 'c3')"
                  />
                  <input
                      v-model="c4"
                      name="c4"
                      required
                      autocomplete="off"
                      class="input2fa"
                      maxlength="1"
                      size="1"
                      @paste="onPaste"
                      @keydown="onKeydown($event, 'c4')"
                  />
                  <input
                      v-model="c5"
                      name="c5"
                      required
                      autocomplete="off"
                      class="input2fa"
                      maxlength="1"
                      size="1"
                      @paste="onPaste"
                      @keydown="onKeydown($event, 'c5')"
                  />
                  <input
                      v-model="c6"
                      name="c6"
                      required
                      autocomplete="off"
                      class="input2fa"
                      maxlength="1"
                      size="1"
                      @paste="onPaste"
                      @keydown="onKeydown($event, 'c6')"
                  />
                </v-flex>

                <!-- Remember Me -->
                <v-layout>
                  <v-flex xs12 md6 class="mt-32">
                    <v-btn type="submit" :loading="form.busy" color="primary"
                    >Confirm</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { Form, HasError, AlertError } from "vform";
import { bugsnagClient } from "~/plugins";
import swal from "sweetalert2";
import axios from "axios";
import Vue from "vue";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";

export default {
  metaInfo() {
    return { title: this.$t("login") };
  },
  components: {
    HasError: HasError,
    AlertError: AlertError
  },

  data: () => ({
    form: new Form({
      email: "",
      password: "",
      code: ""
    }),
    reset_success: false,
    type: "password",
    password_icon: "/img/eye-icon.svg",
    email: "",
    password: "",
    step: 1,
    c1: "",
    c2: "",
    c3: "",
    c4: "",
    c5: "",
    c6: "",
    windowWidth: window.innerWidth
  }),
  mounted: async function() {
    this.reset_success = this.$route.query.status === "reset-success";
  },
  methods: {
    onPaste(evt) {
      const usingArrayFrom = Array.from(
          evt.clipboardData.getData("text").trim()
      );

      let counter = 1;
      for (let value of usingArrayFrom) {
        switch (counter) {
          case 1:
            this.c1 = value;
            break;
          case 2:
            this.c2 = value;
            break;
          case 3:
            this.c3 = value;
            break;
          case 4:
            this.c4 = value;
            break;
          case 5:
            this.c5 = value;
            break;
          case 6:
            this.c6 = value;
            break;
        }
        counter++;
      }
    },
    onKeydown(event, model) {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
      if (
          (event.keyCode >= 48 && event.keyCode <= 57) ||
          (event.keyCode >= 96 && event.keyCode <= 105)
      ) {
        event.target.value = String.fromCharCode(
            96 <= event.keyCode && event.keyCode <= 105
                ? event.keyCode - 48
                : event.keyCode
        );
        this[model] = String.fromCharCode(
            96 <= event.keyCode && event.keyCode <= 105
                ? event.keyCode - 48
                : event.keyCode
        );
        const next = event.target.nextElementSibling;
        if (next === null) return;
        event.preventDefault();
        event.target.nextElementSibling.focus();
      } else if (event.keyCode == 8 || event.keyCode == 46) {
        this[model] = "";
        const next = event.target.previousElementSibling;
        if (next === null) return;
        event.preventDefault();
        event.target.previousElementSibling.focus();
      }
      return;
    },
    async check2fa() {
      // Submit the form.
      try {
        this.email = this.form.email;
        this.password = this.form.password;

        const { data } = await this.form.post("/api/v1/check2fa");

        if (data.status) {
          this.step = 2;
          Vue.nextTick(() => {
            this.$refs.c1.focus();
          });
        } else {
          await this.login(this.email, this.password);
        }
      } catch (error) {
        if (!error.response || error.response.status !== 401) {
          bugsnagClient.notify(error);
        }

        if (error.response.status === 401) {
          await swal({
            title: "Login failed",
            text: "Please try again...",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }
      }
    },
    async login(email, password) {
      // Submit the form.

      try {
        const { data } = await axios.post("/api/v1/login", {
          email: email,
          password: password,
          tz: moment.tz.guess()
        });

        // Save the token.
        this.$store.dispatch("auth/saveToken", {
          token: data.token
        });

        // Fetch the user.
        await this.$store.dispatch("auth/fetchUser");

        // Redirect home.
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        if (!error.response || error.response.status !== 401) {
          bugsnagClient.notify(error);
        }

        if (error.response.status === 401) {
          await swal({
            title: "Login failed",
            text: "Please try again...",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }

        throw error;
      }
    },
    async login2fa() {
      // Submit the form.
      try {
        const { data } = await axios.post("/api/v1/login", {
          email: this.email,
          password: this.password,
          code: this.c1 + this.c2 + this.c3 + this.c4 + this.c5 + this.c6,
          tz: moment.tz.guess()
        });

        // Save the token.
        this.$store.dispatch("auth/saveToken", {
          token: data.token
        });

        // Fetch the user.
        await this.$store.dispatch("auth/fetchUser");

        // Redirect home.
        this.$router.push({ name: "dashboard" });
      } catch (error) {
        if (!error.response || error.response.status !== 401) {
          bugsnagClient.notify(error);
        }

        if (error.response.status === 401) {
          await swal({
            title: "Login failed",
            text: "Please try again...",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark ? "swal-type-error-dark" : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }

        throw error;
      }
    },
    togglePassword() {
      this.type = this.type === "password" ? "text" : "password";
      this.password_icon =
          this.type === "password"
              ? "/img/eye-icon.svg"
              : "/img/eye-open-icon.svg";
    }
  }
};
</script>

<style scoped>
.bg-container {
  background: url("/img/background-center.png") center top no-repeat,
  url("/img/background-full.jpg") repeat;
  height: 100%;
}
.no-shadow {
  box-shadow: none !important;
}
.no-background {
  background: transparent;
}
.placeholer-color >>> input::placeholder {
  color: #b8d2ff !important;
  opacity: 1;
}
>>> .v-input__slot::before {
  border-color: #b8d2ff !important;
}

>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  margin: 22px 6px 8px;
  box-shadow: none !important;
}

>>> .v-btn .link {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  text-decoration-line: underline;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-left: 9px;
  text-decoration-color: #0051dd;
}
.headline {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 40px !important;
  line-height: 48px !important;
  letter-spacing: 0.02em !important;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.head-description {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #103a84;
  margin-bottom: 0px;
}
.head-description a {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  text-decoration-line: underline;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-left: 9px;
  text-decoration-color: #0051dd;
}
.mt-30 {
  margin-top: 30px;
}
.mt-32 {
  margin-top: 32px;
}
.description-2fa {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #b8d2ff;
}
.input2fa {
  border: 1.5px solid #b8d2ff;
  box-sizing: border-box;
  border-radius: 5px;
  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 0px 8px;
  width: 40px;
  height: 55px;
  font-size: 28px;
  padding-left: 10px;
}
.status-success {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #7ec171;
}

.forgot-password {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  background: -webkit-linear-gradient(#468aff, #0051dd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: none;
}

.mt-156 {
  margin-top: 156px;
}
.pt-110 {
  padding-top: 110px;
}
.pt-156 {
  padding-top: 156px;
}

.v-messages__message {
  color: #ed4242;
}
@media (max-width: 1440px) {
  .bg-container {
    background: url("/img/background-center.png") center top no-repeat,
    url("/img/background-full-1440.jpg") repeat;
    height: 100%;
  }
}
@media (max-width: 768px) {
  .bg-container {
    background: #ffffff url("/img/bg-tablet-left.jpg") left top no-repeat;
    height: 100%;
  }
}

@media (max-width: 600px) {
  .bg-container {
    background: #ffffff;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/auth/login.vue